// src/components/providers/compare-adaptex-context.ts
function _array_like_to_array(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _array_with_holes(arr) {
  if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _iterable_to_array_limit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _non_iterable_rest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _sliced_to_array(arr, i) {
  return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _array_like_to_array(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { createContext } from "react";
// src/components/providers/compare-adaptex-arms.ts
var SHOW_PROMPT = "show-prompt";
var TOGGLE_PLACEMENT = "toggle-placement";
var TICK_BOX_VISIBILITY = "tick-box-visibility";
var SHOW_PROMPT_YES = "yes";
var SHOW_PROMPT_NO = "no";
var TOGGLE_PLACEMENT_NONE = "none";
var TOGGLE_PLACEMENT_FILTERS_SHEET = "filter-sheet";
var TOGGLE_PLACEMENT_SRP = "srp";
var TICK_BOX_VISIBILITY_TRUE = "true";
var TICK_BOX_VISIBILITY_FALSE = "false";
var _obj;
// src/components/providers/compare-adaptex-context.ts
var defaultState = {
  campaignId: "",
  payloadId: "",
  arms: (_obj = {}, _define_property(_obj, SHOW_PROMPT, SHOW_PROMPT_NO), _define_property(_obj, TOGGLE_PLACEMENT, TOGGLE_PLACEMENT_NONE), _define_property(_obj, TICK_BOX_VISIBILITY, TICK_BOX_VISIBILITY_FALSE), _obj),
  enabled: false,
  propertySearchCriteria: void 0
};
var defaultValue = [defaultState, function () {
  return void 0;
}];
var CompareAdaptExContext = createContext(defaultValue);
// src/components/providers/compare-adaptex-provider.tsx
import React, { useCallback, useMemo, useRef, useState } from "react";
import { useExperiment } from "@shared-ui/experiment-context";
var Provider = CompareAdaptExContext.Provider;
var CompareAdaptExProvider = function (param) {
  var propertySearchCriteria = param.propertySearchCriteria,
    children = param.children;
  var bucket = useExperiment("M1_Web_SDUI_Property_Comparison_Tool_MVP_on_SRP").exposure.bucket;
  var _useState = _sliced_to_array(useState(function () {
      var toggleState = typeof localStorage === "undefined" ? null : localStorage.getItem("toggleState");
      return _object_spread_props(_object_spread({}, defaultState), {
        propertySearchCriteria: propertySearchCriteria,
        enabled: toggleState ? toggleState === String(true) : bucket === 1
      });
    }), 2),
    state = _useState[0],
    setState = _useState[1];
  var setStateWithSideEffects = useCallback(function (stateOrCallback) {
    var nextState = typeof stateOrCallback === "function" ? stateOrCallback(state) : stateOrCallback;
    localStorage.setItem("toggleState", String(nextState.enabled));
    return setState(nextState);
  }, [state, setState]);
  var value = useMemo(function () {
    return [state, setStateWithSideEffects];
  }, [state, setStateWithSideEffects]);
  var previousPropertySearchCriteria = useRef(propertySearchCriteria);
  if (propertySearchCriteria !== previousPropertySearchCriteria.current) {
    setState(function (currentState) {
      return _object_spread_props(_object_spread({}, currentState), {
        propertySearchCriteria: propertySearchCriteria
      });
    });
    previousPropertySearchCriteria.current = propertySearchCriteria;
    return null;
  }
  return /* @__PURE__ */React.createElement(Provider, {
    value: value
  }, children);
};
export { CompareAdaptExContext, CompareAdaptExProvider, SHOW_PROMPT, SHOW_PROMPT_NO, SHOW_PROMPT_YES, TICK_BOX_VISIBILITY, TICK_BOX_VISIBILITY_FALSE, TICK_BOX_VISIBILITY_TRUE, TOGGLE_PLACEMENT, TOGGLE_PLACEMENT_FILTERS_SHEET, TOGGLE_PLACEMENT_NONE, TOGGLE_PLACEMENT_SRP, defaultState };